/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 */

export function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number = 250,
  immediate?: boolean,
  context?: any
): (this: any, ...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null
  return function (this: any, ...args: Parameters<T>) {
    const later = () => {
      timeout = null
      if (!immediate) {
        func.apply(context || this, args)
      }
    }
    const callNow = immediate && !timeout
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(later, wait)
    if (callNow) {
      func.apply(context || this, args)
    }
  }
}
